module.exports = __webpack_public_path__ + "media/src/images/icons/filter-948f4d00f41200b90420a0c4c97d3c8f.svg";